export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-10 md:mb-12 max-w-xl mx-auto">
          欢迎漫友投稿、反馈问题或提出合作建议，让刃牙漫画在线观看平台变得更好
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 mb-10">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 cursor-pointer transition-all duration-300 hover:border-primary-200/60">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-50">
              <i className="ri-mail-line text-xl text-primary-500"></i>
            </div>
            <h3 className="text-sm font-heading text-foreground-950 mb-1">投稿邮箱</h3>
            <p className="text-xs text-foreground-400">submission@baki-manga.com</p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 cursor-pointer transition-all duration-300 hover:border-primary-200/60">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-50">
              <i className="ri-discord-line text-xl text-accent-500"></i>
            </div>
            <h3 className="text-sm font-heading text-foreground-950 mb-1">漫友社区</h3>
            <p className="text-xs text-foreground-400">加入刃牙漫画讨论群</p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 cursor-pointer transition-all duration-300 hover:border-primary-200/60">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-secondary-50">
              <i className="ri-bug-line text-xl text-secondary-500"></i>
            </div>
            <h3 className="text-sm font-heading text-foreground-950 mb-1">问题反馈</h3>
            <p className="text-xs text-foreground-400">提交阅读过程中的问题</p>
          </div>
        </div>
      </div>
    </section>
  );
}